let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4cIR5")).then(() => parcelRequire('aOUdU'));